SelectBox = App.loadClass 'core::SelectBox'
ValidationEngine = App.loadClass 'core::ValidationEngine'

class exports.Contracts_Contract_Dialog_Handler extends FullPageHandler

    init: () ->
        @layoutUrl = 'backend/portal/contracts/load-layout-contract-dialog'
        @saveUrl = 'backend/portal/contracts/save-contract'

        @savingBtnMsg = 'Saving Contract...'

        @destroyOnSave = false
        @slideFormUp = false
        @refreshNavHandler = true

        @createDialog()

        @validator = new ValidationEngine()


    getPostData: () ->
        data =
            id: $('#contract_id').val()
            number: $('#contract_number').val().replace(/\s-\s/g, '')
            year: $('#contract_year').val()
            zone: $('#sales_zone').val()
            fields: $('#sel_contracted_fields>option').map( (i, el) -> el.value ).get()

        return JSON.stringify data


    afterLoadLayout: (selector, response) ->
        @openDialog()

        if response.status?.type isnt 'success'
            return

        ths = this

        if @parent.currMode is 'Edit'
            @parent.disableDialogForm()

        @dialog.find('#sel_grower').bind 'change', () =>
            @updateFields()

        @dialog.find('#btn_add_fields').bind 'click', () =>
            @moveOptions($('#sel_fields'), $('#sel_contracted_fields'))

            @updateTotalAcres()


        @dialog.find('#btn_remove_fields').bind 'click', () =>
            @moveOptions($('#sel_contracted_fields'), $('#sel_fields'))
            uid = $('#sel_grower').val()
            $('#sel_fields').find('option[data-uid!="' + uid + '"]').remove()

            @updateTotalAcres()


        $('#contract_year').unbind().bind 'change', () ->
            ths.updateFields()

        @validator.makeFormValidator 'contracts_dialog', '#form_contracts_dlg', '#contracts_dialog_errors', (valid) =>
            if valid
                # if the dialog is valid, then we can finally save
                @save('Saving Contract...')

        @validator.registerRule
            'selector': '.validate-contracted-fields'
            'text': 'You must add at least one field to the contract'
            'func': (elem) ->
                return $(elem).find('option').length > 0


    submitAction: () ->
        # validate the sidebar first - if it's valid, then it will validate the dialog
        @parent.validator.validateForm('contracts_sidebar')



    updateFields: ()  ->
        uid = $('#sel_grower').val()

        filter = {}
        filter.uid = { '==': parseInt(uid) }
        #filter.year = [parseInt($("#contract_year").val()),null]

        fields = @taffyObjects['fields'](filter).order('fname').distinct('fid', 'fname')
        SelectBox.render fields, $('#sel_fields'), []

        # Add the title text and uid to the options
        for elem in $('#sel_fields option')
            elem = $(elem)
            val = elem.val()
            if $('#sel_contracted_fields option[value="' + val + '"]').length
                elem.remove()
            else
                field = @taffyObjects['fields'](
                    'fid':
                        '==': val
                ).select('uname', 'year_contracts', 'year')

                @configureFieldElem(elem)

                for year_field in field
                    if year_field[2]? and
                            year_field[2].toString() is $('#contract_year').val().toString() and
                            year_field[1] > 0
                        elem.css(color: '#bbbbbb')
                        elem.attr('disabled', 'disabled')
                        break

        $('#sel_fields option').tooltip()


    configureFieldElem: (elem) ->
        field = @taffyObjects['fields'](
            'fid':
                '==': elem.val()
        ).select('uname', 'uid', 'tillable_acres')

        elem.attr('title', field[0][0])
        elem.attr('data-uid', field[0][1])
        elem.attr('data-acres', field[0][2])


    loadFields: () ->
        $('#sel_contracted_fields').empty()

        for elem in $('input[name="contract_field"]')
            fid = $(elem).val()
            #console.log fid
            filter =
                'fid':
                    '==': parseInt(fid)
            field = @taffyObjects['fields'](filter).select('fname', 'uname', 'tillable_acres')

            elem = $("<option value='#{fid}'>#{field[0][0]}</option>")
            @configureFieldElem elem

            $('#sel_contracted_fields').append(elem)

        @updateTotalAcres()

        $('#sel_contracted_fields option').tooltip()


    disableForm: () ->
        @dialog.find('select, span.btn').attr('disabled', 'disabled')


    enableForm: () ->
        @dialog.find('select, span.btn').removeAttr('disabled')


    updateTotalAcres: () ->
        totacres = 0
        for elem in $('#sel_contracted_fields option')
            acres = $(elem).data('acres')
            totacres += parseFloat(acres)

        $('#span_total_acres').text( totacres.toFixed(1) )
